import { createApp } from 'vue'
import router from './router'
import App from '@/App'

const app = createApp(App)
app.use(router)
app.config.devtools = true

if (process.env.NODE_ENV === 'development') {
  // if ('__VUE_DEVTOOLS_GLOBAL_HOOK__' in window) {
  // // Here__ VUE_ DEVTOOLS_ GLOBAL_ HOOK__ . Vue assigns a createapp instance
  //   window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app
  // }
  app.config.devtools = true
}

app.mount('#app')
// Vue.config.devtools = true
